module.exports = __webpack_public_path__ + "static/img/jingcha.735b455f.svg";